<template>
  <div class="account-setting">
    <!-- <Header title="门店服务" /> -->
    <div class="index_top">
      <van-image
        fit="cover"
        :round="true"
        width="4rem"
        height="4rem"
        src="https://img.yzcdn.cn/vant/cat.jpeg"
      />
      <div class="top_span">
        <h2>{{ userinfo.merchantName }}</h2>
      </div>
    </div>
    <div class="panel2" @click="stockClick">
      <div class="panel_left">
        <span style="font-size: 1.5rem; height: 30px">{{
          JSON.stringify(amount) != " " ? amount / 100 : ""
        }}</span>
        <span style="font-size: 0.8rem">本月进货金额(元)</span>
      </div>
      <div>
        <p>查看进货明细</p>
      </div>
    </div>

    <div class="panel" @click="detailClick">
      <div class="panel_left">
        <span style="font-size: 1.5rem; height: 30px">{{
          JSON.stringify(source) != "{}" ? source.totalAmount / 100 : ""
        }}</span>
        <span style="font-size: 0.8rem">本月出库金额(元)</span>
      </div>
      <div>
        <p>查看明细</p>
      </div>
    </div>

    <div class="index_menu">
      <p style="text-align: initial; font-weight: 900; font-size: 1.2rem">
        常用工具
      </p>
      <van-grid clickable column-num="4" icon-size="40">
        <van-grid-item
          :icon="require('@/assets/delivery/car.png')"
          link-type="reLaunch"
          to="/inspection/inspectionFirst"
          text="逢车必检"
        />
        <van-grid-item
          :icon="require('@/assets/delivery/Booking.png')"
          link-type="reLaunch"
          to="/appointment/detail"
          text="预约管理"
        />
        <van-grid-item
          :icon="require('@/assets/delivery/standard.png')"
          link-type="navigateTo"
          url="https://embed.sopei.cn/#/b751af04a339944b"
          text="油标查询"
        />
        <!-- <van-grid-item
          :icon="require('@/assets/delivery/CashBook.png')"
          link-type="reLaunch"
          to="/cashbook/cashbooks"
          text="资金账本"
        /> -->
        <van-grid-item
          :icon="require('@/assets/delivery/order2erp.png')"
          link-type="reLaunch"
          :url="`https://cm.haferd.net/m/login?tel=${userinfo.phone}`"
          text="下单进货"
        />
        <van-grid-item
          :icon="require('@/assets/delivery/management.png')"
          link-type="navigateTo"
          to="/clerk/salesclerkList"
          text="店员管理"
        />
        <!-- <van-grid-item
          :icon="require('@/assets/delivery/DrainageActivities.png')"
          link-type="reLaunch"
          to="/activity/list"
          text="引流活动"
        /> -->
        <van-grid-item
          :icon="require('@/assets/delivery/DrainageActivities.png')"
          link-type="reLaunch"
          to="/index"
          text="引流活动"
        />
        <van-grid-item
          :icon="require('@/assets/delivery/shop.png')"
          link-type="navigateTo"
          to="/subordinate/StoreSdata"
          text="商户信息"
        />
        <van-grid-item
          :icon="require('@/assets/delivery/set.png')"
          link-type="reLaunch"
          to="/user/accountSetting"
          text="账户设置"
        />
      </van-grid>
    </div>
    <van-button
      type="primary"
      size="large"
      round
      color="#23b53b"
      style="width: 65%; font-size: 1.3rem; margin-top: 3rem; margin-bottom: 3rem;"
      @click="onClick"
      >扫码出库</van-button
    >
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import { weiXingSDK } from "@/api/user";
import { report, company_amount } from "@/api/exwarehouse";

export default {
  name: "Home",
  beforeRouteEnter(to, from, next) {
    if (from.path === "/") {
      weiXingSDK(encodeURIComponent(location.href)).then((res) => {
        wx.config({
          debug: false,
          appId: res.appId,
          timestamp: res.timestamp,
          nonceStr: res.nonceStr,
          signature: res.signature,
          jsApiList: ["scanQRCode"],
        });
      });
    }
    next();
  },
  data() {
    return {
      LogisticsCode: "",
      userinfo: JSON.parse(sessionStorage.getItem("userInfo")),
      source: {},
      amount: ''
    };
  },
  mounted() {
    if (this.userinfo.role != 1) {
      this.$router.push({
        name: "Scan",
      });
    }
    this.salesReport();
    this.stockList();
  },
  methods: {
    salesReport() {
      var time = new Date();
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      report(year, month)
        .then((res) => {
          this.source = res.result;
        })
        .catch((err) => {
          console.log(err);
        });

      this.times = year + "年" + month + "月";
    },
    // 进货金额
    stockList() {
      var time = new Date();
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      company_amount(year, month)
        .then((res) => {
          this.amount = res.result
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onClick() {
      this.$router.push({
        name: "Scan",
      });
    },
    detailClick() {
      this.$router.push({
        name: "salesReport",
      });
    },
    stockClick() {
      this.$router.push({
        name: "stockList",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .van-grid-item__text {
  font-size: 14px;
}
.account-setting {
  .index_top {
    display: flex;
    justify-content: start;
    align-items: center;
    margin-left: 3rem;
    margin-top: 1.5rem;
    .top_span {
      margin-left: 1rem;
      color: #606060;
    }
  }
  .panel {
    width: 90%;
    background: #3da0f0;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    line-height: 50px;
    height: 80px;
    color: #fff;
    border-radius: 0.5rem;
    margin-top: 1.5rem;
    .panel_left {
      display: flex;
      flex-direction: column;
      font-size: small;
      margin-right: 6rem;
    }
  }
  .panel2 {
    width: 90%;
    background: #58b9ac;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    line-height: 50px;
    height: 80px;
    color: #fff;
    border-radius: 0.5rem;
    margin-top: 1.5rem;
    .panel_left {
      display: flex;
      flex-direction: column;
      font-size: small;
      margin-right: 6rem;
    }
  }
  .index_menu {
    width: 90%;
    margin: 0 auto;
    margin-top: 2rem;
  }
  .scan {
    width: 75%;
    margin: 0 auto;
    height: 60px;
    background: #23b53b;
    border-radius: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 6rem;
  }
}
</style>
